export enum ProductThemeId {
  Amsterdam = '6d629564-0ce9-4f6a-9975-ed8b177ea99a',
  BlackJack = 'f15cdfb2-b14a-4451-9b24-7bf352dd4b13',
  Clean = '16df80d3-9fbd-4ae5-a9f3-b1b41f9f12c5',
  Contemporary = '4c344c48-18b0-49cc-a532-960ceb0548fb',
  Doug = '5faa1d21-210d-42a9-bde2-45f2735b9150',
  Foggy = '6ccadae2-32e9-41f3-800d-3892f542d911',
  Framed = 'a37d21f4-c7b1-4fef-a3dd-229123f19c78',
  HouseOfDank = '88baf3b8-5854-490f-911c-b0b078dc864f',
  IngramAndSons = 'bab4c33b-8dc3-42f9-abc4-b38b051f60f6',
  Jimmy = '00cd83be-f0b2-43ad-bc90-f6b7316d477e',
  KillerQueen = '8c29dc40-d6c8-44e8-8bb2-8736399f79aa',
  LaCanapa = 'c92cf051-6bdc-46e2-8e16-ba2de771f111',
  LobsterButter = '519f33ca-b0c5-4c27-84a6-7fc7bb4dbbcc',
  LuxLeaf = 'ed69992b-c6ee-4def-9ae9-ee704b4971e8',
  MaryJane = 'dd26558f-7764-4b6a-a5de-1c8aa8075cf9',
  Night = 'c55704e4-1e83-4923-a679-dd3b07af6a59',
  NorthernLights = '9ed2f3e2-d1f1-4ef9-864f-c086dd113cc8',
  PurLife = '56c3663b-3876-4de8-82f1-5fc497c411c1',
  RoyalBud = '26774cb6-31c4-42c7-9bf0-4c315160536d',
  Runtz = 'ff8b52ae-ba7b-4e79-99f3-12af225335f0',
  SmallJane = '4dcbdd0a-8676-4794-acac-34385a624d5d',
  SoulBud = 'a4e7e8c9-bd80-4091-8c48-8270cb63fb3a',
  SuperLemonHaze = '763d369d-77ca-45c0-bf55-2f78214c732f',
  Tight = '662e9521-8468-458b-898c-b52b84409037',
  TrueNorth = 'e4c7418e-1274-11ec-82a8-0242ac130003',
  TrueNorthDark = '2ecda1f7-0d68-435f-9204-8a6543e7746a',
  Weed = 'f4f2d795-4fb5-40ba-bc7f-8831cd8e44ae',
  WeedStore = 'eed1eff4-4e19-11ec-81d3-0242ac130003'
}

export enum ReportThemeId {
  OrderReview = '6b26f4f8-b73c-4b5f-8afe-38ff28ce2797'
}

export enum PrintThemeId {
  Banded = '0d4e32d3-1c67-4b76-b830-9a61cf95b69c',
  BellaLuna = '62c30193-6a63-4e6b-8425-3bb261d90158',
  Blended = 'fac549b3-c129-496b-b88f-425c7d15edb8',
  BudSupply = '75c26a50-4d6d-11ec-81d3-0242ac130003',
  CalyxTrichomes = '7a0973d2-0c32-11ec-b15b-0242ac130002',
  Clean = '08be6db4-c085-4e51-a031-81f8d8b498e2',
  ComeToBaskTriFold = 'fa0b1d4a-e4e9-4b59-96f4-e0b956207868',
  DoubleDutch = '73032d65-f24a-4e2e-86da-e9b37fef763a',
  DoubleGelato = 'ee18e406-3a26-4ed6-b0b9-2bf909433251',
  DougPrint = '938ad358-166b-4df2-9242-9e6e5399fafb',
  Fika = '449bac79-8dfb-4ce2-b763-6ee28792a1ad',
  FireAndFlower = 'bd5d742e-a24a-438f-a5cc-7763ac5e32ed',
  GridLines = '9e3c971f-6583-41ff-ae36-fdb53f8cc02a',
  IngramAndSonsSingleFold = 'be8ab8fd-30a9-4443-ad8b-5f3faded2b4a',
  JimmyPrint = '21a04768-4ab9-4077-ac18-fa49da866416',
  LaCanapaPrint = '9e45a742-e8f4-4958-9738-4f66975e1bc9',
  OGKushPrint = 'ab2598f5-b514-43d1-833a-62210da24d58',
  PlainJane = 'f44475a3-2525-4455-940f-ef1646cd7fa0',
  PlantlifeOneColumn = '312fdf5c-9a5d-437d-98eb-c585b7fb7728',
  PlantlifeCheapWeed = 'c31d94ce-b024-47f0-9836-c49d4734f71c',
  Plantlife = '7b0ceab2-7963-403d-81b7-e908547f46ca',
  PlantlifeNonSmokable = 'd6bfeeaf-80d9-4b0b-bfe5-df674382eabf',
  SoulBudPrint = '9c3508d2-5723-471c-be54-cd1cd0143b36',
  SpaceMonkeyPrint = '35e0a627-55ad-432d-86e5-0042ba1e452c',
  SpiritLeaf = 'd3f46d37-b769-4990-aec4-fc802c2ee1ee',
  Sprout = '715b73bf-30ca-4577-90ec-0e15fee74025',
  TightPrint = 'b6bee564-2e4d-4f18-ba59-c4a903fa9fb8',
  TrueNorthPrint = '25789743-6cee-410c-9cc6-9c6ea1f658fe'
}

export enum MarketingThemeId {
  Combo = '38978015-c814-46b5-a9f3-40358ec6e864',
  FeaturedCategory = 'ed40262e-721d-11ec-90d6-0242ac120003',
  MarketingLoop = 'bff0954e-9092-4ab5-a5c9-d27afd3c755b',
  MarketingProductFeature = 'a9ecd951-0db2-4cdf-a7bc-7832c0f52da0',
  SmartPlaylist = '36197fc0-c4d0-11ed-afa1-0242ac120002'
}

export enum SpotlightThemeId {
  Top = 'd90a6b3c-e01f-11eb-ba80-0242ac130004'
}

export enum ShelfTalkerThemeId {
  Doug = '199d6964-0a35-41b1-a16d-346fe7a03608',
  FireAndFlower = '6b6f4882-b701-4a8f-a20e-1961fbce00fb',
  GlassHouse = 'f07650be-b3ba-4570-a3e3-0f1579f2116d'
}

export enum PrintCardThemeId {
  AgentOrange = '2b47f966-0335-409e-b3bc-732051508775',
  Doug = '3f6299a9-0dae-4736-a55f-42a855f68e8d',
  DougAr = '933b3209-9799-4d9f-947d-ada393ce20e6',
  Fika = 'f1f840dc-2676-4c77-862b-b8e6fe1b1042',
  FikaAccessories = 'fa6f13f7-32b3-49d7-99fe-1b9466265b5a',
  FikaBeverage = '8b94c1f3-65e7-48e4-b98a-eadd628bdbad',
  FikaConcentrate = 'e2c02965-d32c-49d2-90ee-d4bdee667da9',
  FikaEdibles = 'ee4674fd-4b74-45a8-ade8-78e1c03a32c6',
  FireAndFlower = '252634b5-39a7-44c6-8923-682c9937d912',
  FireAndFlowerDefault = 'f22f5012-3c7c-4d19-a35a-71633d68f958',
  FireAndFlowerMember = 'c2c6fa53-5003-45e9-92df-d68048aae246',
  FireAndFlowerSale = '4686bde3-3f6b-4b36-9f86-46cc1426cbb5',
  GanjikaHouseBeverage = '60ad535e-71c9-42b2-b04c-fb5ceec14040',
  Generic = '2f380997-796f-4c60-8d08-edd3f06c0e75',
  GlassHouse = 'e7cff563-4c33-4658-8776-4378828d0e1e',
  GlassHouseBrandGroup = 'd7e0fbdf-b029-4b41-bd65-62dab6ba5664',
  Harlequin = 'e3366daa-ab78-4d4a-b6a6-1307d1808526',
  HoneyHaze = '4d8d10ea-07cb-484a-9975-ceb74c82a8df',
  JaneDoe = '791a2021-eafa-4ce4-ba60-2dda403a22bb',
  KOAN = 'be656cfb-4679-42c2-9fc2-699f3e17f696',
  MasterKushStrain = '536cf437-943b-4188-bd1c-91617fa4be31',
  MissJones = 'ba0cae0d-bd50-4629-be02-14a6e1dbaacf',
  NYCD = '43ec36a5-73d9-4c3e-af40-b2cc3cf2973c',
  OGKush = 'fa0b964d-4224-41a8-be57-f768489f5bac',
  Pennywise = 'b1ff7497-5a9c-4817-9eeb-5a7b696a9e87',
  PlainJane = '761684d5-34c6-44ab-8264-3f27dd135ea6',
  Plantlife = 'd1f59b6b-1389-4fce-b76a-59c5c664a183',
  PlantlifeCheapWeed = '98a8c2b3-7fc0-46ee-b24e-3ff81413f29e',
  PopsCannabis = 'd309d758-7c4c-4229-a3bd-fd25bb2aed3c',
  Sessions = '125dfa33-31b7-4b94-88d1-1849aded2814',
  Stiiizy = 'd8237f65-adfc-4f11-b12c-0706e2980008',
  StiiizyStrain = '91f99acd-920d-4365-ac65-48958b6744e0',
  StiiizyWide = '9769bb66-804d-4e87-b699-36956bfdfddb',
  TheWoods = 'fd84d797-82fb-431d-9cf5-66e65629d23b',
  TrueNorthLandscape = '6d201ff3-47ca-4dd4-a676-ce8b74afd4b2',
  TrueNorthPortrait = '81a59084-e8e4-40be-8ba3-31f48f163afa'
}

export enum PrintLabelThemeId {
  BaseInventoryLabel = 'a0e779a9-1d62-4153-aea9-dbc933076423',
  BrandInventoryLabel = '3de31534-2ece-4143-8e94-b8d3f391fbcb',
  PopsInventoryLabel = 'c5b5f873-21c0-4dd1-ba6e-1152f660e254',
  SkuInventoryLabel = '7e387684-f5a9-4652-be19-77091da0ce4b'
}

export type MenuThemeId =
  | ProductThemeId
  | ReportThemeId
  | PrintThemeId
  | MarketingThemeId
  | SpotlightThemeId
  | PrintCardThemeId
  | PrintLabelThemeId;
